const { REACT_APP_API_ENV = 'dev' } = process.env;
const pathConfig: any = {
  dev: {
    LOGIN_PATH: 'https://superapp-public.hdltest.com/app-h5-login/#', //登录项目的地址
    IS_SHOW_VCONSOLE: true, //是否展示vconsole
  },
  qa: {
    LOGIN_PATH: 'https://superapp-public.hdltest.com/app-h5-login/#', //登录项目的地址
    IS_SHOW_VCONSOLE: true, //是否展示vconsole
  },
  pro: {
    LOGIN_PATH: 'https://superapp-public.kiwa-tech.com/app-h5-login/#', //登录项目的地址
    IS_SHOW_VCONSOLE: false, //是否展示vconsole
  },
};
export default pathConfig[REACT_APP_API_ENV];
